import { useAppSelector } from '~system/store/configure-store';
import { selectActiveScope } from '~system/store/scope/scope-selectors';

export const useActiveScope = () => {
  return useAppSelector(selectActiveScope);
};
